import React, {Fragment, useState} from "react";
import {Link} from "gatsby";
import {Col, Row} from "react-bootstrap";
import root from "window-or-global";
import "../../style/animation.scss";
import UtasLogo from "../../images/utas/utas_net_logo.svg";
import UtasWhiteLogo from "../../images/utas/utas_logo_white.svg";
import BackArrow from "../../images/utas/Icon black-arrow-left.svg";

export default function Header() {
  let user;
  const [openMenu, setOpenMenu] = useState(false);
  const pathname = (root.location || {}).pathname || "";
  // const isWhite = pathname.startsWith("/register") && pathname !== "/register";
  const isWhite = pathname.startsWith("/register") && !(pathname === "/register" || pathname === "/register/");
  const isRecover = pathname.startsWith("/forgot-password") && (pathname === "/forgot-password" || pathname === "/forgot-password/");
  const isSignUp = pathname.startsWith("/select-address") && (pathname === "/select-address" || pathname === "/select-address/");
  const isSelectAdd = pathname.startsWith("/select-address") && (pathname === "/select-address" || pathname === "/select-address/");

  function handleCloseMenu() {
    return setOpenMenu(false);
  }

  function handleMenuButtonClick() {
    return setOpenMenu(!openMenu);
  }
  function triggerChat() {
    root.zE("messenger", "open");
    return handleCloseMenu();
  }
  const listItems = () => {
    if (isRecover) {
      return (
        <ul className="vw-menu-recover-list">
          <li className="vw-menu-list-item">
            <img src={BackArrow} alt="back-icon" className="back-arrow"/>
            <a href="/" className="vw-menu-item-anchor">{"BACK"}</a>
          </li>
        </ul>
      );
    } else {
      return (
        <ul className="vw-menu-list">
          <li className="vw-menu-list-item">
            <a href="/" className="vw-menu-item-anchor">{"Home"}</a>
          </li>
          <li className="vw-menu-list-item">
            <a onClick={triggerChat} className="vw-menu-item-anchor">{"Contact Us"}</a>
          </li>
          {!isSignUp && (<li className="vw-menu-list-item">
            <a href="/register/plan" className="vw-menu-item-sign-up">{"Sign Up"}</a>
          </li>)}
        </ul>
      );
    }
  };


  return (
    <div className={`vw-header-container ${openMenu ? " open" : ""} ${isWhite ? "white" : ""}`}>
      <div className={`vw-menu-header ${openMenu ? " open" : ""}`}>
        <div className="vw-menu-logo">
          <a href="/">
            <img className="menu-logo" alt="UTAS Logo" src={UtasLogo}/>
          </a>
          <a href="/">
            <img className="menu-logo-white" alt="UTAS Logo" src={UtasWhiteLogo}/>
          </a>
        </div>
        <div className="vw-menu">
          {listItems()}
          <ul className="vw-menu-hamburger">
            <li
              className="vw-menu-button clearfix"
              onClick={handleMenuButtonClick}
            >
              <MenuButton
                open={openMenu}
                isWhite={!isWhite}
                override={isWhite}
              />
            </li>
          </ul>
        </div>
      </div>

      <div>
        {openMenu && (
          <div className="magictime-300ms vw-mobile-menu">
            <Row className="vw-menurow no-gutters">
              <Col xs={12}>
                <a onClick={triggerChat} className="mobile-menu-item" activeClassName="vw-active">
                  {"Contact Us"}
                </a>
              </Col>
            </Row>
            <Row className="vw-menurow no-gutters">
              {!isSignUp &&
              <Col xs={12} onClick={() => (root.location = "/select-address")} >
                <Link to="/select-address" className="mobile-menu-item" activeClassName="vw-active" onClick={handleCloseMenu}>
                  <div>
                    {"Sign Up"}
                  </div>
                </Link>
              </Col>
              }
              <Col xs={12} onClick={() => user ? (root.location = "/portal") : (root.location = "/login")}>
                {(user) ? (
                  <Fragment/>
                  // <Link to="/portal" className="mobile-menu-item" activeClassName="vw-active" onClick={this.handleCloseMenu}>
                  //   <div className="vw-menu-icon" style={{backgroundImage: `url(${UserCircleWhiteIcon})`}}>
                  //     {"Portal"}
                  //   </div>
                  // </Link>
                ) : (
                  <Link to="/login" className="mobile-menu-item" activeClassName="vw-active" onClick={handleCloseMenu}>
                    <div>
                      {"Home"}
                    </div>
                  </Link>
                )}
              </Col>
            </Row>
          </div>
        )}
      </div>
    </div>
  );
}

function MenuButton({open, isWhite, override, ...rest}) {
  const tricky = {
    display: "block",
    width: "100%",
    height: 2,
    // background: isWhite ? "rgb(0, 0, 0)" : "rgb(255, 255, 255)",
    borderRadius: 1,
    marginBottom: 5,
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
  };
  let span1, span2, span3;
  let backgroundColor;
  if (override) {
    backgroundColor = isWhite ? "black" : "black";
  }
  if (open) {
    span1 = Object.assign({backgroundColor: "white"}, tricky, {
      transform: "translateY(7px) rotate(45deg)",
    });
    span2 = Object.assign({backgroundColor: "white"}, tricky, {
      opacity: 0,
    });
    span3 = Object.assign({backgroundColor: "white"}, tricky, {
      transform: "translateY(-7px) rotate(-45deg)",
      marginBottom: 0,
    });
  } else {
    span1 = Object.assign({backgroundColor}, tricky);
    span2 = Object.assign({backgroundColor}, tricky);
    span3 = Object.assign({backgroundColor}, tricky, {marginBottom: 0});
  }

  return (<div style={{width: 24}} {...rest}>
    <span className={`vw-menu-button-line ${isWhite ? "blue" : "white"}`} style={span1} />
    <span className={`vw-menu-button-line ${isWhite ? "blue" : "white"}`} style={span2}/>
    <span className={`vw-menu-button-line ${isWhite ? "blue" : "white"}`} style={span3} />
  </div>);
}
